export const SERVICE_CARDS = [
  {
    id: "immigration",
    title: "Immigration Help",
    description: "Get authorized help understanding, preparing, filing, and managing eligible immigration matters.",
    cta: "Explore Immigration Services",
    href: "/immigration",
    icon: "Scale",
  },
  {
    id: "home-documents",
    title: "Documents From My Home Country",
    description: "Need a birth certificate, marriage record, police certificate, school record, passport, or other document from abroad? We help coordinate the process.",
    cta: "Get Document Assistance",
    href: "/documents-identity",
    icon: "FileSearch",
  },
  {
    id: "passport-id",
    title: "Passport, ID & Consular Assistance",
    description: "Get help navigating passport renewals, identity documents, consular appointments, and visa or passport photo requirements where permitted.",
    cta: "View Passport & ID Services",
    href: "/documents-identity",
    icon: "BookUser",
  },
  {
    id: "notary-apostille",
    title: "Notary, Apostille & Authentication",
    description: "Prepare documents for use in the United States or internationally through notary, apostille, authentication, legalization, and translation coordination.",
    cta: "Explore Document Services",
    href: "/documents-identity",
    icon: "Stamp",
  },
  {
    id: "itin-tax",
    title: "ITIN & Tax Assistance",
    description: "Get assistance with ITIN applications, Form W-7, tax-document preparation, and financial-start services within our authorized scope.",
    cta: "Explore ITIN & Tax Services",
    href: "/itin-tax",
    icon: "Calculator",
  },
  {
    id: "screening",
    title: "Testing, Background & MVR Services",
    description: "Drug testing, background screening, driving records, fingerprinting, and verification services where available and properly authorized.",
    cta: "View Screening Services",
    href: "/screening",
    icon: "ShieldCheck",
  },
  {
    id: "new-life",
    title: "Starting My Life in the U.S.",
    description: "Need help with identification, banking, insurance, school enrollment, housing, transportation, employment, or other newcomer needs?",
    cta: "Explore New Life Services",
    href: "/new-life",
    icon: "Home",
  },
  {
    id: "citizenship",
    title: "Citizenship & Long-Term Planning",
    description: "Prepare for naturalization, citizenship milestones, and the next stage of your family's U.S. journey.",
    cta: "Explore Citizenship Services",
    href: "/citizenship",
    icon: "Flag",
  },
];

export const JOURNEY_STEPS = [
  { title: "Tell Us What You Need", text: "Share your goals and situation in plain language — no legal knowledge required." },
  { title: "Complete Your Secure Intake", text: "A guided, step-by-step intake organizes your information safely and confidentially." },
  { title: "Meet With Your Full Circle Representative or Navigator", text: "Talk with a real person who listens and helps you understand your options." },
  { title: "Receive Your Personalized Journey Plan", text: "A clear roadmap: what needs to happen, who is responsible, and in what order." },
  { title: "Upload Your Documents", text: "Securely upload documents from your phone or computer — we organize them for you." },
  { title: "We Prepare, Coordinate, Track, or Represent", text: "Within our authorized scope, we do the heavy lifting and keep everything moving." },
  { title: "Receive Updates Through Your Portal", text: "Know where things stand at any moment — messages, deadlines, and next steps in one place." },
  { title: "Complete This Stage", text: "Finish the current milestone with everything documented and organized." },
  { title: "Plan Your Next Milestone", text: "Your journey continues — we help you see and prepare for what comes next." },
];

export const WHY_FULL_CIRCLE = [
  { title: "One Organized Journey", text: "Immigration, documentation, and integration needs organized around one client plan.", icon: "Route" },
  { title: "Clear Communication", text: "Understand what is happening, what is needed, and what comes next.", icon: "MessagesSquare" },
  { title: "Secure Document Management", text: "Upload, receive, review, and organize important documents through your client portal.", icon: "FolderLock" },
  { title: "Personal Guidance", text: "Work with a team that helps you navigate unfamiliar systems and requirements.", icon: "HeartHandshake" },
  { title: "Knowing the Boundaries", text: "We tell clients clearly when a matter requires an attorney, government agency, laboratory, tax professional, insurer, financial professional, or other licensed provider.", icon: "Compass" },
];

export const IMMIGRATION_SERVICES = [
  { title: "Family-Based Immigration", text: "Petitions and processes that help families stay together and reunite in the United States." },
  { title: "Adjustment of Status", text: "Guidance for eligible clients applying for lawful permanent residence from inside the U.S." },
  { title: "Green Card Matters", text: "Renewals, replacements, and related lawful permanent resident documentation." },
  { title: "Consular Processing", text: "Support for cases processed through U.S. embassies and consulates abroad." },
  { title: "Naturalization", text: "Preparation for the journey from permanent resident to U.S. citizen." },
  { title: "Citizenship", text: "Certificates of citizenship and derived or acquired citizenship matters." },
  { title: "Employment Authorization", text: "Work permit applications and renewals for eligible clients." },
  { title: "Travel Documents / Advance Parole", text: "Permission to travel while certain immigration matters are pending." },
  { title: "Change or Extension of Status", text: "Applications to extend a stay or change to a different nonimmigrant category." },
  { title: "Immigration Records / FOIA", text: "Requests for your government immigration records under the Freedom of Information Act." },
  { title: "Requests for Evidence", text: "Organized, timely responses when USCIS asks for more information." },
  { title: "Notices of Intent to Deny", text: "Careful review and response strategy when the government signals an intent to deny." },
  { title: "Humanitarian Immigration", text: "Protection-based programs for people facing danger, violence, or crisis." },
  { title: "Asylum", text: "Help for people who fear returning to their home country because of persecution." },
  { title: "VAWA", text: "Confidential help for survivors of abuse by a U.S. citizen or permanent resident family member." },
  { title: "U Visa", text: "For victims of certain crimes who have helped law enforcement." },
  { title: "T Visa", text: "For survivors of human trafficking." },
  { title: "Temporary Protected Status", text: "TPS registration and re-registration for eligible country nationals." },
  { title: "Waivers", text: "Requests to forgive certain grounds of inadmissibility, where within authorized scope." },
  { title: "Interview Preparation", text: "Practice and preparation so you walk into your interview calm and ready." },
  { title: "Case Strategy and Evidence Preparation", text: "Organizing the facts, documents, and evidence that tell your story clearly." },
];

export const COURT_MATTERS = [
  "Removal / deportation proceedings",
  "Court appearances",
  "Motions",
  "Appeals",
  "Bond-related matters where applicable",
  "Defensive applications for relief",
  "Case review and litigation strategy",
];

export const INTERNATIONAL_DOCUMENTS = [
  "Birth Certificates", "Marriage Certificates", "Death Certificates", "Divorce Records",
  "Police Certificates", "Criminal Record Certificates", "Civil Registry Records",
  "Adoption Records", "Name Change Records", "Citizenship Records", "Nationality Records",
  "Court Records", "School Transcripts", "Diplomas", "University Records",
  "Employment Records where available", "Other official records where legally obtainable",
];

export const PASSPORT_SERVICES = [
  "Passport application assistance",
  "Passport renewal assistance",
  "Expired passport assistance",
  "Lost/stolen passport process assistance",
  "Emergency travel-document coordination",
  "National identification document assistance",
  "Foreign driver's license renewal/replacement coordination where remote processing is permitted",
  "Embassy and consular appointment assistance",
  "Application package preparation",
  "Courier coordination",
];

export const PHOTO_SERVICES = [
  "U.S. Passport Photos",
  "Foreign Passport Photos",
  "Visa Photos",
  "Immigration Photos",
  "Country-specific sizing",
  "Digital photo delivery where permitted",
  "Printed photo packages",
];

export const NOTARY_SERVICES = [
  { title: "Notary Public Services", text: "In-office notarization of affidavits, forms, and personal documents." },
  { title: "Apostille Facilitation", text: "Preparation and submission for documents used in Hague Convention countries." },
  { title: "State Authentication", text: "State-level certification for documents leaving the country." },
  { title: "Federal Authentication", text: "U.S. Department of State authentication when required." },
  { title: "Consular Legalization", text: "Embassy or consulate legalization for non-Hague countries." },
  { title: "Embassy Authentication", text: "Coordination with foreign embassies and consulates." },
  { title: "Certified Translation Coordination", text: "Qualified translations accepted by government agencies." },
  { title: "Document Scanning & Copying", text: "High-quality digital copies for your records and applications." },
  { title: "International Courier Coordination", text: "Tracked, secure shipping of original documents worldwide." },
];

export const ITIN_SERVICES = [
  "ITIN application assistance",
  "Form W-7 assistance",
  "ITIN renewal",
  "Tax-document organization",
  "Tax-return preparation only if properly authorized and registered",
  "Acceptance Agent services only where IRS authorization has been granted",
  "EIN assistance where permitted",
  "Bank-account readiness",
  "Understanding U.S. banking",
  "Credit-building education",
  "Financial-start checklist",
  "Referrals to licensed professionals where appropriate",
];

export const DRUG_TESTING = [
  "DOT testing when qualified",
  "Non-DOT testing",
  "Pre-employment",
  "Random",
  "Post-accident",
  "Return-to-duty coordination",
  "Follow-up testing coordination",
];

export const BACKGROUND_SERVICES = [
  "Background checks",
  "MVR / Motor Vehicle Records",
  "Employment verification",
  "Credential verification",
  "Fingerprinting where available",
];

export const LAB_SERVICES = [
  "DNA / paternity collection coordination",
  "Other specimen collection where legally and professionally permitted",
  "Blood testing only through appropriately licensed personnel and providers",
];

export const NEW_LIFE_SECTIONS = [
  {
    title: "Identity & Government",
    icon: "IdCard",
    items: ["State ID", "Driver's license", "Social Security guidance where eligible", "Local registrations"],
  },
  {
    title: "Banking & Credit",
    icon: "Landmark",
    items: ["Bank account guidance", "Credit education", "Secured credit guidance", "Budgeting", "U.S. financial system orientation"],
  },
  {
    title: "Housing",
    icon: "House",
    items: ["Housing search navigation", "Rental-readiness", "Lease education", "Utility setup guidance"],
  },
  {
    title: "Transportation",
    icon: "Car",
    items: ["Driver licensing guidance", "Transportation resources", "Vehicle purchasing resources", "Auto insurance referrals"],
  },
  {
    title: "Health",
    icon: "HeartPulse",
    items: ["Health insurance navigation", "Provider referrals", "Community health resources"],
  },
  {
    title: "Children & Education",
    icon: "GraduationCap",
    items: ["School enrollment", "Daycare", "College", "Adult education", "ESL programs", "Transcript/credential evaluation coordination"],
  },
  {
    title: "Employment",
    icon: "Briefcase",
    items: ["Résumé assistance", "Job-search support", "Workforce referrals", "Professional credential evaluation", "Licensing navigation", "Employer resources"],
  },
  {
    title: "Community",
    icon: "Users",
    items: ["Community resources", "Local support", "Food/resource referrals where appropriate", "Family resources", "Cultural/community orientation"],
  },
];

export const CITIZENSHIP_SERVICES = [
  "Naturalization eligibility review",
  "N-400 assistance within authorized scope",
  "Citizenship interview preparation",
  "Civics preparation",
  "English preparation resources",
  "Certificate of citizenship matters",
  "Post-naturalization passport guidance",
  "Family immigration planning following naturalization",
  "Long-term family planning",
];

export const RESOURCE_CATEGORIES = [
  "Immigration Basics", "USCIS", "Immigration Court", "Citizenship", "International Documents",
  "Passports", "Apostilles", "ITIN & Tax", "Driver's License", "Banking", "Credit",
  "Housing", "Health Insurance", "School Enrollment", "Employment", "Newcomer Checklists",
  "Emergency Resources",
];

export const RESOURCES = [
  { id: "r1", title: "Immigration Basics: Key Words in Plain English", category: "Immigration Basics", summary: "Understand common terms like petitioner, beneficiary, priority date, and adjustment of status.", checklist: ["Learn the difference between a visa and status", "Know what a receipt notice means", "Understand what an RFE is", "Keep copies of everything you file"] },
  { id: "r2", title: "How to Read a USCIS Receipt Notice", category: "USCIS", summary: "Your receipt notice confirms your case was received. Learn what each field means and why the receipt number matters.", checklist: ["Find your 13-character receipt number", "Check your name spelling immediately", "Note the receipt date", "Store a copy in your portal"] },
  { id: "r3", title: "Preparing for a USCIS Biometrics Appointment", category: "USCIS", summary: "What biometrics are, what to bring, and what happens at the appointment.", checklist: ["Bring your appointment notice", "Bring valid photo ID", "Arrive 15 minutes early", "Do not reschedule unless necessary"] },
  { id: "r4", title: "What To Do If You Receive Court Papers", category: "Immigration Court", summary: "A Notice to Appear is serious. Learn the first steps to take and how quickly you should seek help.", checklist: ["Do not ignore the notice", "Write down your hearing date", "Seek qualified legal help immediately", "Keep your address updated with the court"] },
  { id: "r5", title: "Naturalization: The N-400 Checklist", category: "Citizenship", summary: "Documents and preparation needed for a naturalization application.", checklist: ["Green card copy", "5 years of address history (3 if married to a citizen)", "5 years of work history", "Travel history outside the U.S.", "Tax records", "Selective Service confirmation if applicable"] },
  { id: "r6", title: "Studying for the Civics Test", category: "Citizenship", summary: "The 100 official civics questions, how the test works, and study strategies.", checklist: ["Study the official 100 questions", "Practice speaking answers out loud", "Learn about your state and local officials", "Take practice tests"] },
  { id: "r7", title: "Requesting a Birth Certificate From Abroad", category: "International Documents", summary: "General steps for obtaining civil records from your home country while living in the U.S.", checklist: ["Identify the correct civil registry office", "Gather proof of identity", "Check whether an apostille is needed", "Plan for translation into English"] },
  { id: "r8", title: "Police Certificates: What They Are and When You Need One", category: "International Documents", summary: "Many immigration applications require police certificates from countries where you have lived.", checklist: ["List every country where you lived 6+ months", "Check each country's request process", "Order early — some take months", "Check validity periods"] },
  { id: "r9", title: "Passport Renewal From Inside the U.S.", category: "Passports", summary: "How consulates handle renewals, what documents you typically need, and how appointments work.", checklist: ["Locate your nearest consulate", "Check appointment availability", "Prepare photos that meet requirements", "Bring your old passport"] },
  { id: "r10", title: "Apostille vs. Authentication vs. Legalization", category: "Apostilles", summary: "Which certification your document needs depends on where it will be used.", checklist: ["Confirm the destination country", "Check if the country is in the Hague Convention", "Determine if state or federal certification applies", "Ask about translation requirements"] },
  { id: "r11", title: "ITIN Basics: Who Needs One and Why", category: "ITIN & Tax", summary: "An ITIN lets people without a Social Security number file taxes and open financial doors.", checklist: ["Confirm you are not eligible for an SSN", "Gather identity documents", "Complete Form W-7 carefully", "Understand renewal requirements"] },
  { id: "r12", title: "Getting Your First State ID or Driver's License", category: "Driver's License", summary: "Steps, documents, and testing requirements for Florida identification.", checklist: ["Gather proof of identity and legal presence", "Collect two proofs of residential address", "Study for the written exam", "Schedule your DMV appointment"] },
  { id: "r13", title: "Opening Your First U.S. Bank Account", category: "Banking", summary: "What banks ask for, how accounts work, and how to avoid fees.", checklist: ["Bring photo ID", "Bring proof of address", "Ask about minimum balance requirements", "Set up online banking and alerts"] },
  { id: "r14", title: "Building Credit From Zero", category: "Credit", summary: "How the U.S. credit system works and safe first steps to build a score.", checklist: ["Understand what a credit score is", "Consider a secured credit card", "Pay every bill on time", "Keep balances low"] },
  { id: "r15", title: "Renting Your First Apartment", category: "Housing", summary: "Leases, deposits, tenant rights, and how to prepare a strong rental application.", checklist: ["Prepare proof of income", "Understand the lease before signing", "Document the unit condition at move-in", "Know your tenant rights"] },
  { id: "r16", title: "Health Insurance Options for Newcomers", category: "Health Insurance", summary: "Marketplace plans, Medicaid, community clinics, and how to choose coverage.", checklist: ["Check marketplace eligibility", "Note open enrollment dates", "Find community health centers nearby", "Keep records of all coverage"] },
  { id: "r17", title: "Enrolling Your Child in School", category: "School Enrollment", summary: "Every child has the right to attend public school. What schools ask for and how enrollment works.", checklist: ["Gather proof of address", "Bring immunization records", "Request records from previous schools", "Ask about English learner programs"] },
  { id: "r18", title: "Your Newcomer First-90-Days Checklist", category: "Newcomer Checklists", summary: "A practical roadmap for your first three months in the United States.", checklist: ["Secure safe housing", "Obtain identification", "Open a bank account", "Register children for school", "Find a local clinic", "Learn your transportation options", "Save emergency numbers"] },
  { id: "r19", title: "Finding Work: Résumés and Job Search Basics", category: "Employment", summary: "How U.S. résumés work, where to search, and how workforce centers can help.", checklist: ["Create a one-page résumé", "Register with your local workforce center", "Prepare for common interview questions", "Verify your work authorization"] },
  { id: "r20", title: "Emergency Resources and Safety Planning", category: "Emergency Resources", summary: "What to do in emergencies, hotlines that help in many languages, and how to prepare your family.", checklist: ["Save 911 for life-threatening emergencies", "Know your local non-emergency number", "Create a family emergency plan", "Keep important documents in a safe place"] },
];

export const FAQS_HOME = [
  { q: "Is CF Full Circle a law firm?", a: "CF Full Circle is an Immigration & Integration Center. Immigration legal representation is offered only through appropriately authorized attorneys or DOJ Accredited Representatives acting within their authorized scope. When a matter requires a differently licensed professional, we tell you clearly." },
  { q: "Do you guarantee my case will be approved?", a: "No. No one can guarantee immigration outcomes, processing times, or government decisions. Government agencies make all decisions. What we can promise is organization, clear communication, and careful preparation within our authorized scope." },
  { q: "What makes Full Circle different from other immigration services?", a: "Most services focus on one filing. We organize your whole journey — immigration, documents from your home country, ITIN and tax, identification, housing, school enrollment, and citizenship planning — into one clear roadmap with one secure portal." },
  { q: "How do I get started?", a: "Click 'Start Your Journey' and complete the guided intake. It takes about 10 minutes. A Full Circle representative will review your information and contact you with next steps." },
  { q: "Is my information confidential?", a: "Yes. Your documents and case information live in your secure client portal — never in ordinary email. We use role-based access so only the team members working on your journey can see your file." },
];

export const OFFICE = {
  address: "101 NE 3rd Ave, Suite 1500",
  city: "Fort Lauderdale, FL 33301",
  email: "fciicenter@gmail.com",
  phone: "(833) 477-7587",
  hours: [
    { days: "Monday – Friday", time: "9:00 AM – 6:00 PM" },
    { days: "Saturday", time: "By appointment" },
    { days: "Sunday", time: "Closed" },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1627662235844-6f5d8f54816b?crop=entropy&cs=srgb&fm=jpg&q=85",
  community: "https://images.unsplash.com/photo-1758272133786-ee98adcc6837?crop=entropy&cs=srgb&fm=jpg&q=85",
  family: "https://images.unsplash.com/photo-1596510914914-e14c6f59f925?crop=entropy&cs=srgb&fm=jpg&q=85",
  counseling: "https://images.unsplash.com/photo-1758876202980-0a28b744fb24?crop=entropy&cs=srgb&fm=jpg&q=85",
  workspace: "https://images.unsplash.com/photo-1590649681928-4b179f773bd5?crop=entropy&cs=srgb&fm=jpg&q=85",
  passport: "https://images.unsplash.com/photo-1454496406107-dc34337da8d6?crop=entropy&cs=srgb&fm=jpg&q=85",
  stamps: "https://images.unsplash.com/photo-1581553673739-c4906b5d0de8?crop=entropy&cs=srgb&fm=jpg&q=85",
  signing: "https://images.unsplash.com/photo-1564846824194-346b7871b855?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const ROLE_LABELS = {
  client: "Client",
  administrator: "Administrator",
  accredited_representative: "DOJ Accredited Representative",
  attorney: "Attorney / Supervisor",
  case_manager: "Case Manager",
  newcomer_navigator: "Newcomer Navigator",
  document_specialist: "Document Specialist",
  tax_specialist: "Tax / ITIN Specialist",
  testing_staff: "Testing Staff",
  notary: "Notary",
  client_support: "Client Support",
  accounting: "Accounting",
};

export const CASE_STATUS_PROGRESS = (status, statuses) => {
  const i = statuses.indexOf(status);
  if (i < 0) return 0;
  return Math.round((i / (statuses.length - 1)) * 100);
};
